module.exports = require('./helpers/bundle-url').getBundleURL('9iXDo') + "ding.941a4a28.wav" + "?" + Date.now();